"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reconcileCSV = exports.reconcile = exports.reconcile_internal = exports.hasDuplicatFinleyReceivableId = exports.printReceivableResults = void 0;
// this is not typesafe, do not use outside of debug
const getRequiredFinleyFields = (rec) => {
    return rec.baseFields;
};
const printReceivableResults = (prefix, borrowingBaseReceivables) => {
    const enabled = false;
    // walk thru each borrowing base receivables,
    if (enabled) {
        borrowingBaseReceivables.forEach((rec) => {
            const baseFields = rec.baseFields;
            const borrowingBaseAmount = rec.borrowingBaseFields.borrowingBaseAmount;
            // eslint-disable-next-line no-console
            console.log(Object.assign(Object.assign({ prefix }, baseFields), { borrowingBaseAmount }));
        });
    }
};
exports.printReceivableResults = printReceivableResults;
const hasDuplicatFinleyReceivableId = (prefix, receivables) => {
    const ids = new Map();
    const duplicates = new Set();
    receivables.forEach((receivable, index) => {
        const { finley_receivable_id } = receivable;
        if (ids.has(finley_receivable_id)) {
            duplicates.add(finley_receivable_id);
        }
        ids.set(finley_receivable_id, index);
    });
    if (duplicates.size > 0) {
        console.log(`${prefix}: Found duplicates:`, Array.from(duplicates));
        return true;
    }
    return false;
};
exports.hasDuplicatFinleyReceivableId = hasDuplicatFinleyReceivableId;
const round = (value) => Math.round(value * 100) / 100;
const reconcile_internal = (receivables, loanBalances) => {
    const loanToCollatAccounts = {};
    // maintain total pre-alocation value for each collat account.
    const collatPreAllocValues = new Map();
    const collatPostAllocation = new Map();
    const finleyReceivableIds = new Set();
    receivables.forEach((rec) => {
        var _a;
        const { pre_allocation_lendable_value, post_allocation_lendable_value, collateral_account_number, loan_account_number, finley_receivable_id, } = rec;
        // maintain loanToCollatAccounts
        const loanAllocations = loanToCollatAccounts[loan_account_number] || {};
        loanAllocations[collateral_account_number] = round((loanAllocations[collateral_account_number] || 0) +
            post_allocation_lendable_value);
        loanToCollatAccounts[loan_account_number] = loanAllocations;
        // maintain total post-allocation value for each collat account.
        const collatPostAlloc = collatPostAllocation.get(collateral_account_number) || 0;
        collatPostAllocation.set(collateral_account_number, round(collatPostAlloc + post_allocation_lendable_value));
        // maintain total loan balance allocated
        loanAllocations.total_allocated = round((loanAllocations.total_allocated || 0) + post_allocation_lendable_value);
        loanAllocations.loan_balance =
            ((_a = loanBalances.find((loanBalance) => loanBalance.loanAccountNumber === loan_account_number)) === null || _a === void 0 ? void 0 : _a.loanBalance) || -1;
        loanAllocations.excess_allocated = round(loanAllocations.total_allocated - loanAllocations.loan_balance);
        // maintain total pre-alocation value for each collat account.
        if (!finleyReceivableIds.has(finley_receivable_id)) {
            finleyReceivableIds.add(finley_receivable_id);
            const collat = collatPreAllocValues.get(collateral_account_number) || 0;
            // add pre_allcation value if we are seeing this receivable for 1st time.
            collatPreAllocValues.set(collateral_account_number, round(collat + pre_allocation_lendable_value));
        }
    });
    // add collat values to loanToCollatAccounts
    collatPreAllocValues.forEach((value, collat) => {
        const preAllocationValues = loanToCollatAccounts.collat_pre_allocation || {};
        preAllocationValues[collat] = value;
        loanToCollatAccounts.collat_pre_allocation = preAllocationValues;
        const postAllocationValues = loanToCollatAccounts.collat_post_allocation || {};
        postAllocationValues[collat] = collatPostAllocation.get(collat) || 0;
        loanToCollatAccounts.collat_post_allocation = postAllocationValues;
    });
    // Construct a new object for loanToCollatAccounts where total_allocated comes first
    const orderedLoanToCollatAccounts = {};
    Object.keys(loanToCollatAccounts).forEach((loanAccountNumber) => {
        const accountAllocations = loanToCollatAccounts[loanAccountNumber];
        const orderedAllocations = {};
        // Ensure loan_balance comes first
        if (accountAllocations.loan_balance !== undefined) {
            orderedAllocations.loan_balance = accountAllocations.loan_balance;
            delete accountAllocations.loan_balance; // Remove it to avoid duplication
        }
        // Ensure total_allocated comes next
        if (accountAllocations.total_allocated !== undefined) {
            orderedAllocations.total_allocated = accountAllocations.total_allocated;
            delete accountAllocations.total_allocated; // Remove it to avoid duplication
        }
        // Ensure diff comes next
        if (accountAllocations.excess_allocated !== undefined) {
            orderedAllocations.excess_allocated = accountAllocations.excess_allocated;
            delete accountAllocations.excess_allocated; // Remove it to avoid duplication
        }
        // Add the rest of the collateral accounts
        Object.keys(accountAllocations).forEach((collateralAccountNumber) => {
            orderedAllocations[collateralAccountNumber] =
                accountAllocations[collateralAccountNumber];
        });
        orderedLoanToCollatAccounts[loanAccountNumber] = orderedAllocations;
    });
    // loanToCollatArray has each row as a loan account and columns as collat accounts.
    // and one extra column for sum of all collat accounts against loan.
    // and one extra row for pre allocation collat values.
    // and one extra row for post allocation collat values.
    //   it produces output like this:
    // ┌────────────────────────┬────────────┬─────────────────┬────────────┬────────────┬────────────┐
    // │        (index)         │ 2D59422818 │ total_allocated │ AFE2469681 │ 2D78431816 │ 2D06172516 │
    // ├────────────────────────┼────────────┼─────────────────┼────────────┼────────────┼────────────┤
    // │       9500113728       │   45587    │     299797      │   254210   │            │            │
    // │       9500113706       │            │     5872247     │   446155   │  5426092   │            │
    // │       9500113629       │            │    12357240     │  1036800   │            │  11320440  │
    // │ collat_pre_allocation  │   45587    │                 │  1737165   │  5426092   │  11320440  │
    // │ collat_post_allocation │   45587    │                 │  1737165   │  5426092   │  11320440  │
    // └────────────────────────┴────────────┴─────────────────┴────────────┴────────────┴────────────┘
    console.log('Loan Accounts to Collateral 3');
    console.table(orderedLoanToCollatAccounts);
    // console.log(orderedLoanToCollatAccounts);
};
exports.reconcile_internal = reconcile_internal;
const reconcile = (borrowingBaseReceivables, loanBalances) => {
    const recs = borrowingBaseReceivables.map((rec) => {
        // extract exposure and advance rate
        const finleyFields = getRequiredFinleyFields(rec);
        const { pre_allocation_lendable_value, post_allocation_lendable_value, collateral_account_number, loan_account_number, finley_receivable_id, } = finleyFields;
        return {
            pre_allocation_lendable_value,
            post_allocation_lendable_value,
            collateral_account_number,
            loan_account_number: loan_account_number || 'unassigned',
            finley_receivable_id,
        };
    });
    (0, exports.reconcile_internal)(recs, loanBalances);
};
exports.reconcile = reconcile;
const reconcileCSV = ({ rrtCsv, loanBalancesCSV, }) => {
    const mappedRRT = rrtCsv.map((rec) => ({
        // convert from csv to required fields.
        finley_receivable_id: String(rec.baseFields_finley_receivable_id),
        pre_allocation_lendable_value: Number(rec.baseFields_pre_allocation_lendable_value),
        post_allocation_lendable_value: Number(rec.baseFields_post_allocation_lendable_value),
        collateral_account_number: String(rec.baseFields_collateral_account_number),
        loan_account_number: String(rec.baseFields_loan_account_number),
    }));
    const loanBalances = loanBalancesCSV.map((rec) => ({
        loanAccountNumber: String(rec.loanAccountNumber),
        loanBalance: Number(rec.loanAccountBalance),
    }));
    (0, exports.reconcile_internal)(mappedRRT, loanBalances);
};
exports.reconcileCSV = reconcileCSV;
//# sourceMappingURL=debug.js.map